import React from "react";
import assets from "../assets";
import Button from "../Components/Button";
import "./index.css";

const Footer = ({ handleActivePopUp }) => {
  return (
    <footer className="footer flex justifyCenter">
      <img className="lightFooter" src={assets.light.footer} alt="Light" />
      <div className="container-lg flex flexCol alignCenter relative">
        <div className="flex flexRow logoFooter">
          {assets.econCuadro}
          {assets.econCompleto}
        </div>

        <div className="menu flex flexRow gap">
          <a href="#hero">Home</a>
          <a href="#explore">Explore</a>
          <a href="#build">Build</a>
          <a href="#econbrain">Econ Brain</a>
        </div>

        <div className="flex flexRow footerButtons">
          <Button
            link={"#contact"}
            text={"Build now"}
            build
            handleActivePopUp={handleActivePopUp}
            popData="build"
          />
          <Button
            link={"#contact"}
            text={"Apply now"}
            handleActivePopUp={handleActivePopUp}
            popData="white"
          />
        </div>
        <a className="gotop" href="#hero">
          Go to top
          <svg
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M16.9405 9.88456L9.05591 2L0.999944 10.056"
                stroke="#D9D9D9"
                strokeWidth="2"
              />
            </g>
          </svg>
        </a>
        <div className="rs">
          <a
            href="https://www.linkedin.com/company/econ-blockchain/"
            target="_blank"
            rel="noreferrer"
          >
            {assets.rs.in}
          </a>
          <a
            href="https://www.linkedin.com/company/econ-blockchain/"
            target="_blank"
            rel="noreferrer"
          >
            {assets.rs.yt}
          </a>
          <a
            href="https://www.linkedin.com/company/econ-blockchain/"
            target="_blank"
            rel="noreferrer"
          >
            {assets.rs.tw}
          </a>
          <a
            href="https://www.linkedin.com/company/econ-blockchain/"
            target="_blank"
            rel="noreferrer"
          >
            {assets.rs.tg}
          </a>
        </div>

        <span className="copyr">© 2022 ECON</span>
      </div>
    </footer>
  );
};

export default Footer;
